export class User {
    id: number;
    username: string;
    name: string;
    surname: string;
    roles = [];
    status: string;
    rattachementList = [];
    controlTypesList = [];
    /**
     * Derived by the server's sanitizeUser(). The `mfa` block itself never
     * crosses the API -- it holds the sealed TOTP secret and the recovery-code
     * hashes -- so these two facts are all the admin screens get, and all they
     * need to decide whether a reset is warranted.
     */
    mfaEnrolled?: boolean;
    mfaMethod?: string;
    /**
     * Chosen on the profile screen, from a fixed palette. Empty or absent means
     * the avatar falls back to a colour derived from the username, which is what
     * every account had before anyone chose one.
     */
    avatarColor?: string;
  }
  